import React from 'react';

function useDebounce<T>(value: T, delay?: number): T {
  const mounted = React.useRef(false);
  const [debouncedValue, setDebouncedValue] = React.useState<T>(value);

  React.useEffect(() => {
    let timer: ReturnType<typeof setTimeout> | undefined;

    if (mounted) {
      timer = setTimeout(() => setDebouncedValue(value), delay || 500);
    }

    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [value, delay]);

  React.useEffect(() => {
    mounted.current = true;

    return () => {
      mounted.current = false;
    };
  }, []);

  return debouncedValue;
}

export default useDebounce;
